import React, { ButtonHTMLAttributes, ReactElement } from 'react';
import VoxelButton, { VoxelButtonColor } from '../Buttons/VoxelButton';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export interface VoxelToggleButtonProps
  extends Pick<
    ButtonHTMLAttributes<HTMLButtonElement>,
    'onClick' | 'onMouseDown' | 'onMouseUp' | 'type' | 'disabled'
  > {
  title: string;
  selected: boolean;
  tooltip?: string;
  icon?: ReactElement<FontAwesomeIconProps>;
  className?: string;
  color?: VoxelButtonColor;
}

const VoxelToggleButton: React.FC<VoxelToggleButtonProps> = ({
  onClick,
  onMouseDown,
  onMouseUp,
  disabled,
  title,
  selected,
  tooltip,
  icon,
  className,
  color,
  ...otherProps
}) => {
  return (
    <VoxelButton
      startIcon={icon}
      title={title}
      tooltip={tooltip}
      onClick={onClick}
      disabled={disabled}
      color={color ?? (selected ? 'primary' : 'white')}
      shape="square"
      size="md"
      className={`
      ${!selected && !color ? 'hover:bg-white hover:opacity-90' : ''} 
      shadow-sm rounded-none first:rounded-l-lg last:rounded-r-lg border border-gray-200 even:border-l-0 even:border-r-0 last:even:border-r text ${className} 
      `}
    />
  );
};

export default VoxelToggleButton;
